export default {
      id: "tile-batch-entry-usage",
      viewBox: "0 0 39 42",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#tile-batch-entry",
      toString: function () {
        return this.url;
      }
    }